module.exports = __webpack_public_path__ + "img/full1-min.50d4ece5.png";